export const ServiceLicenseCancelCancel = (context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { contractPack: { selectProduct } } = store.state

  const close = () => {
    context.emit('closeServiceLicenseCancel')
  }
  const submit = () => {
    // API処理が早くローディングが表示されないので、同期処理に変更
    store
      .dispatch('common/showLoading')
      .then(() => {
        store
          .dispatch('contractPack/cancelCancellation', selectProduct)
          .then(() => {
            store.dispatch('common/showToast', { text: '解約予約を取り消しました' })
            router.push({ path: '/pc/service' })
          })
          .catch(err => {
            store.dispatch('common/showNotice', { title: 'エラー', text: err.error_message })
          })
          .finally(() => {
            context.emit('closeServiceLicenseCancel')
            store.dispatch('common/hideLoading')
          })
      })
  }

  return {
    selectProduct,
    close,
    submit
  }
}
